import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *章节列表
 * @param params
 * 
*/

export const chapterList = params => Http.get(`${baseUrl}/chapter`, { params })

/**
 *章节详情
 * @param classChapterId
 * 
*/

export const chapterInfo = classChapterId => Http.get(`${baseUrl}/chapter/${classChapterId}` )

/**
 *学生列表
 * @param classChapterId
 * 
*/

export const studentList = classChapterId => Http.get(`${baseUrl}/class/user/quality/${classChapterId}`)

/**
 *评价详情
 * @param params
 * 
*/

export const appraiseDetail = params => Http.get(`${baseUrl}/class/user/quality/${params.classChapterId}/${params.userId}`)

/**
 *保存评价
 * @param params
 * 
*/

export const saveAppraise = params => Http.post(`${baseUrl}/class/user/quality`, params)


/**
 *完成素养评价
 * @param classChapterId
 * 
*/

export const completeAppraise = classChapterId => Http.put(`${baseUrl}/class/user/quality/${classChapterId}/complete`)
